import { MessageCircle } from "lucide-react";

// Floating WhatsApp click-to-chat button. Rendered globally in App.js so it
// appears on every page.
export const WhatsAppButton = () => {
  return (
    <a
      href="https://wa.me/919819300292"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Cocoamaya on WhatsApp"
      data-testid="whatsapp-float-btn"
      className="fixed z-40 flex items-center justify-center rounded-full shadow-lg hover:scale-105 transition-transform"
      style={{
        bottom: "1.25rem",
        right: "1.25rem",
        width: "52px",
        height: "52px",
        background: "#25D366",
      }}
    >
      <MessageCircle size={26} strokeWidth={2} color="#FFFFFF" fill="#FFFFFF" />
    </a>
  );
};
